import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { elementStylingMap } from '@angular/core/src/render3/instructions';
import { ThrowStmt } from '@angular/compiler';
import { TranslateService } from '@ngx-translate/core';
import { StoreSelectComponent } from '../store-select/store-select.component';

@Component({
  selector: 'app-production',
  templateUrl: './production.component.html',
  styleUrls: ['./production.component.css']
})
export class ProductionComponent implements OnInit {

  public menu_item_id = '51';
  public add_auth;

  private dp = [];
  production_content = [];
  production_content_id = [];

  // sub_item_no;
  // sub_item_number;
  //units = [];
  // available = true;

  storeDialogRef: MatDialogRef<StoreSelectComponent>;

  displayedColumns = ['sub_item_no', 'main_item_name', 'unit_name', 'quantity', 'available_count', 'total_quantity'];  // 'stock_no'
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  model = {
    'table_name': 'production', 'production_id': '0', 'production_no': '', 'sub_item_number': '',
    'production_date': '', 'quantity': '', 'unit_id': '', 'stock_no': '',
    'store_id': this.applicationConstants.user_branch_info.user_store_id,
    'flag': 'new', 'key': 'production_id', 'primary_sub_item_number': '', 'primary_quantity': ''
  };

  data_mode = {
    'production_date': new Date(), 'unit_name': '', 'output_qty': '', 'is_expire': '',
    'expiry_date': new Date()
  };

  stock_model = {
    'table_name': 'stock', 'stock_id': '0', 'stock_no': '',
    'store_id': this.applicationConstants.user_branch_info.user_store_id, 'sub_item_number': '',
    'stock_date': '', 'flag': 'new', 'key': 'stock_id', 'quantity': '', 'production_no': ''
  };

  base_model = {
    'table_name': 'stock_base', 'baseline_id': '0', 'sub_item_number': '', 'stock_no': '',
    'store_id': this.applicationConstants.user_branch_info.user_store_id,
    'base_date': '', 'baseline_amount': '', 'is_manual': '2', 'flag': 'new', 'key': 'baseline_id',
    'source': 'production', 'cost_per_unit': '0', 'production_no': ''
  };

  search_obj = {
    'placeholder': 'اسم/ رقم الصنف', 'class_name': 'longSearchField',
    'table_list': [{
      'table_name': '`main_item`', 'selected_no': 'sub_item_no',
      'field_list': ['main_item_name', 'main_item_name_en'],
      'join_table': '`sub_item`',
      'join_field_list': ['sub_item_no'],
      'join_condition': " AND `main_item`.`main_item_id` = `sub_item`.`main_item_id` AND `main_item`.`main_item_type` = 'industrial' AND `sub_item`.`is_sale` = '1'"
    }]
  };

  // search_obj = {
  //   'placeholder': 'اسم الصنف', 'class_name': 'longSearchField',
  //   'table_list': [{
  //     'table_name': '`main_item`', 'selected_no': 'sub_item_no',
  //     'field_list': ['main_item_name', 'main_item_name_en'],
  //     'join_table': '`sub_item`',
  //     'join_condition': " AND `main_item`.`main_item_id` = `sub_item`.`main_item_id` AND `main_item`.`main_item_type` = 'industrial' AND `sub_item`.`is_sale` = '1'"
  //   }]
  // };

  // sub_item_no_search = {
  //   'placeholder': 'رقم الصنف', 'class_name': 'smallSearchField',
  //   'table_list': [{
  //     'table_name': '`sub_item`', 'selected_no': 'sub_item_no',
  //     'field_list': ['sub_item_no'],
  //     'join_table': '`main_item`',
  //     'condition': " AND `sub_item`.`main_item_id` = `main_item`.`main_item_id` AND `main_item`.`main_item_type` = 'industrial' AND `sub_item`.`is_sale` = '1'"
  //   }]
  // };

  //     'join_table': '`main_item`',
  //     'condition': " AND `main_item`.`main_item_id` = `sub_item`.`main_item_id` AND `main_item`.`main_item_type` = 'industrial' AND `sub_item`.`is_sale` = '1'"

  Sub_item_Placeholder; Success_Msg; Error_Msg; Prod_Date_Msg;
  Prod_Item_Msg; Prod_Quant_Msg; Expiry_Msg; Industrial_Item_Msg;
  Total_Quant_Msg1; Total_Quant_Msg2;


  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private router: Router, private route: ActivatedRoute,
    public translate: TranslateService, public dialog: MatDialog) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Sub_item_Placeholder').subscribe((res: string) => {
      this.Sub_item_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Sub_item_Placeholder;

    translate.get('Prod_Date_Msg').subscribe((res: string) => {
      this.Prod_Date_Msg = res;
    });

    translate.get('Prod_Item_Msg').subscribe((res: string) => {
      this.Prod_Item_Msg = res;
    });

    translate.get('Prod_Quant_Msg').subscribe((res: string) => {
      this.Prod_Quant_Msg = res;
    });

    translate.get('Expiry_Msg').subscribe((res: string) => {
      this.Expiry_Msg = res;
    });

    translate.get('Industrial_Item_Msg').subscribe((res: string) => {
      this.Industrial_Item_Msg = res;
    });

    translate.get('Total_Quant_Msg1').subscribe((res: string) => {
      this.Total_Quant_Msg1 = res;
    });

    translate.get('Total_Quant_Msg2').subscribe((res: string) => {
      this.Total_Quant_Msg2 = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

  }

  ngOnInit() {
    // check add authorization
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);

    //if the user has not select a store yet:
    // if (this.applicationConstants.user_branch_info.user_store_id == '0') {

    let user_id = this.applicationConstants.user_info['user_id'];
    //get store list:
    let query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `store`.`branch_id` AND `store`.`status` = '1' AND `branch_auth`.`status` = '1' AND" +
      " `branch_auth`.`branch_id` = '" + this.applicationConstants.user_branch_info.user_branch_id +
      "' AND `branch_auth`.`user_id` = '" + user_id + "' AND `branch_auth`.`store_id` = `store`.`store_id`";

    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let store_list = [];
        store_list = data.data['list'];

        if (store_list.length > 1) {
          let dialog_data = store_list;
          this.storeDialogRef = this.dialog.open(StoreSelectComponent, {
            hasBackdrop: false,
            data: dialog_data
          });
          this.storeDialogRef
            .afterClosed()
            .subscribe(result => {
            });
        }
        else {
          this.applicationConstants.user_branch_info.user_store_id = store_list['0']['store_id'];
          this.applicationConstants.user_branch_info.user_store_name = store_list['0']['store_name'];
        }
      });
    // }

    this.model['production_date'] = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" +
      new Date().getDate();

    this.route.params.subscribe(params => {
      if (params['no'] != undefined) {
        this.model['production_no'] = params['no'];

        let obj = { cmd: 'getSubItemContent', production_no: this.model['production_no'] };
        this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            let production = data.status.msg[0];
            console.log(production);

            (document.getElementById('search_value_0') as HTMLInputElement).value = production['main_item_name'] +
              '-' + production['main_item_name_en'] + '-' + production['sub_item_no'];
            this.model['production_id'] = production['production_id'];
            this.model['sub_item_number'] = production['sub_item_number'];
            this.model['production_date'] = production['production_date'];
            this.model['quantity'] = production['quantity'];
            this.model['unit_id'] = production['unit_id'];
            if (production['is_expire'] == '1') {
              this.model['expiry_date'] = production['expiry_date'];
              this.data_mode['expiry_date'] = new Date(production['expiry_date']);
            }
            this.model['stock_no'] = production['stock_no'];
            this.model['store_id'] = production['store_id'];
            this.model['flag'] = 'update';
            this.model['primary_sub_item_number'] = production['primary_sub_item_number'];
            this.model['primary_quantity'] = production['primary_quantity'];

            this.data_mode['production_date'] = new Date(production['production_date']);
            this.data_mode['unit_name'] = production['unit_name'];
            this.data_mode['output_qty'] = production['output_qty'];
            this.data_mode['is_expire'] = production['is_expire'];

            this.stock_model['stock_id'] = production['stock_id'];
            this.stock_model['stock_no'] = production['stock_no'];
            this.stock_model['store_id'] = production['store_id'];
            this.stock_model['sub_item_number'] = production['primary_sub_item_number'];
            this.stock_model['stock_date'] = production['production_date'];
            this.stock_model['flag'] = 'update';
            this.stock_model['quantity'] = production['primary_quantity'];
            this.stock_model['production_no'] = this.model['production_no'];

            this.base_model['baseline_id'] = production['baseline_id'];
            this.base_model['sub_item_number'] = production['primary_sub_item_number'];
            this.base_model['stock_no'] = production['stock_no'];
            this.base_model['store_id'] = production['store_id'];
            this.base_model['base_date'] = production['production_date'];
            this.base_model['baseline_amount'] = production['primary_quantity'];
            this.base_model['flag'] = 'update';
            this.base_model['cost_per_unit'] = production['cost_per_unit'];
            this.base_model['production_no'] = this.model['production_no'];
            this.production_content_id = production.production_content_id;

            this.dp = production.sub_item_content;
            this.dataSource = new MatTableDataSource(this.dp);
            this.dataSource.sort = this.sort;
            this.calculate_total();
            // content = data.status.msg[0];
            // 
            // if (content.available_count != undefined)
            // element.unit_id = content.unit_id;
            // element.available_count = content.available_count;
            // element.available_stock = content.available_stock;
          });

        // let query, obj;

        // // get production information
        // query = "SELECT `production`.*, `sub_item`.`sub_item_no`, `sub_item`.`sub_item_id`, `main_item`.`main_item_name`, " + 
        //   "`main_item`.`main_item_name_en`, `unit`.`unit_name`, `unit`.`unit_name_en` FROM `production`, `sub_item`, " + 
        //   "`main_item`, `unit` WHERE `production`.`production_no` = '" + this.model['production_no'] + 
        //   "' AND `production`.`sub_item_number` = `sub_item`.`sub_item_number` AND " + 
        //   "`sub_item`.`main_item_id` = `main_item`.`main_item_id` AND `sub_item`.`unit_id` = `unit`.`unit_id`";
        // obj = { cmd: 'getList', query: query };

        // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        // .subscribe(data => {
        //   this.applicationConstants.appComp.hideBusyCursor();

        //   let result = data.data['list']['0']
        //   this.model['production_id'] = result['production_id'];
        //   this.model['production_date'] = result['production_date'];
        //   this.data_mode['production_date'] = new Date(result['production_date'].substring(0, 4) + '-' + 
        //     result['production_date'].substring(5, 7) + '-' + result['production_date'].substring(8, 10));
        //   this.model['sub_item_number'] = result['sub_item_number'];
        //   this.model['quantity'] = result['quantity'];
        //   this.model['unit_id'] = result['unit_id'];
        //   this.model['stock_no'] = result['stock_no'];

        //   (document.getElementById('search_value_0') as HTMLInputElement).value = result['main_item_name'] + ' - ' + 
        //     result['main_item_name_en'];
        //   (document.getElementById('search_value_1') as HTMLInputElement).value = result['sub_item_no'];
        //   this.data_mode['unit_name'] = result['unit_name'];

        //   // // get sub item content for quantity
        //   // query = "SELECT * FROM `sub_item_content`";

        //   // get production content
        //   query = "SELECT `production_content`.*, `sub_item`.`sub_item_no`, `sub_item`.`sub_item_id`, `main_item`.`main_item_name`, " + 
        //     "`main_item`.`main_item_name_en`, `unit`.`unit_name`, `unit`.`unit_name_en`, `sub_item_content`.`quantity`" + 
        //     " FROM `production_content`, `sub_item`, `main_item`, `unit`, `sub_item_content`" + 
        //     " WHERE `production_content`.`production_no` = '" + this.model['production_no'] + 
        //     "' AND `production_content`.`sub_item_number` = `sub_item`.`sub_item_number` AND " + 
        //     "`sub_item`.`main_item_id` = `main_item`.`main_item_id` AND `sub_item`.`unit_id` = `unit`.`unit_id` AND " + 
        //     "`sub_item`.`sub_item_id` = `sub_item_content`.`content_id` AND `sub_item_content`.`sub_item_id` = '" + 
        //     result['sub_item_id'] + "'";

        //   obj = { cmd: 'getList', query: query };
        //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        //     .subscribe(data => {
        //       this.applicationConstants.appComp.hideBusyCursor();
        //       this.production_content = data.data['list'];
        //       let found = false;

        //       this.production_content.forEach(element => {
        //         found = false;
        //         this.dp.forEach(element1 => {
        //           if (element1.sub_item_number == element.sub_item_number) {
        //             found = true;
        //             element1.total_quantity += element.qty;
        //           }
        //         });

        //         if (!found) {
        //           element.total_quantity = element.qty;
        //           this.dp.push(element);
        //         }
        //       });
        //       this.dataSource = new MatTableDataSource(this.dp);
        //       this.dataSource.sort = this.sort;
        //     });
        // });

      }

    });
  }

  onChangeSearch = function (search_result: object) {
    // console.log(search_result);
    // this.sub_item_no = search_result['no'];

    if (search_result['no'] != '') {
      let sub_item_no = search_result['no'];

      let store_id = this.applicationConstants.user_branch_info.user_store_id;
      let obj = { cmd: 'getSubItemContent', sub_item_no: sub_item_no, store_id: store_id };

      this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          let sub_item = data.status.msg[0];
          console.log(sub_item);

          this.model['sub_item_number'] = sub_item['sub_item_number'];
          this.model['unit_id'] = sub_item['unit_id'];
          this.model['stock_no'] = sub_item['stock_no'];
          this.model['primary_sub_item_number'] = sub_item['primary_sub_item_number'];

          this.data_mode['unit_name'] = sub_item['unit_name'];
          this.data_mode['output_qty'] = sub_item['primary_quantity'];
          this.data_mode['is_expire'] = sub_item['is_expire'];
          this.data_mode['expiry_date'] = '';

          this.stock_model['stock_no'] = sub_item['stock_no'];
          this.stock_model['sub_item_number'] = sub_item['primary_sub_item_number'];

          this.base_model['sub_item_number'] = sub_item['primary_sub_item_number'];
          this.base_model['stock_no'] = sub_item['stock_no'];
          this.base_model['cost_per_unit'] = sub_item['cost_per_unit'];

          this.dp = sub_item.sub_item_content;
          this.dataSource = new MatTableDataSource(this.dp);
          this.dataSource.sort = this.sort;

          if (this.model['quantity'] != '')
            this.calculate_total();

          // content = data.status.msg[0];
          // 
          // if (content.available_count != undefined)
          // element.unit_id = content.unit_id;
          // element.available_count = content.available_count;
          // element.available_stock = content.available_stock;
        });

      // let sub_item_id;

      // let name_query = "SELECT `main_item`.`main_item_name`, `main_item`.`main_item_name_en`," +
      //   " `sub_item`.`sub_item_no` FROM `main_item`, `sub_item` WHERE `sub_item`.`sub_item_no` = '" + sub_item_no +
      //   "' AND `sub_item`.`main_item_id` = `main_item`.`main_item_id`";
      // let name_obj = { cmd: 'getList', query: name_query };

      // this.utils.invokeHttp(this.applicationConstants.generalFile, name_obj)
      //   .subscribe(data => {
      //     this.applicationConstants.appComp.hideBusyCursor();
      //     let sub_item_name = data.data['list']['0'];
      //     //console.log(sub_item_name);
      //     (document.getElementById('search_value_0') as HTMLInputElement).value = sub_item_name.main_item_name + ' - ' + 
      //       sub_item_name.main_item_name_en;
      //     (document.getElementById('search_value_1') as HTMLInputElement).value = sub_item_name.sub_item_no;

      //   });

      //   let unit_query = "SELECT `unit`.`unit_name`, `unit`.`unit_id`, `sub_item`.`sub_item_id`, `sub_item`.`sub_item_number` FROM " +
      //     "`sub_item`, `unit` WHERE `sub_item`.`sub_item_no` = '" + sub_item_no +
      //     "' AND `sub_item`.`unit_id` = `unit`.`unit_id`";
      //   let unit_obj = { cmd: 'getList', query: unit_query };

      //   this.utils.invokeHttp(this.applicationConstants.generalFile, unit_obj)
      //     .subscribe(data => {
      //       this.applicationConstants.appComp.hideBusyCursor();
      //       //console.log(data.data['list']);
      //       let sub_item = data.data['list']['0'];
      //       sub_item_id = sub_item['sub_item_id'];
      //       this.sub_item_unit = sub_item['unit_name'];
      //       this.model['sub_item_number'] = sub_item['sub_item_number'];
      //       this.base_model['sub_item_number'] = sub_item['sub_item_number'];
      //       this.model['unit_id'] = sub_item['unit_id'];
      //       this.sub_item_number = sub_item['sub_item_number'];

      //       let query = "SELECT `sub_item_content`.*, `main_item`.`main_item_name`, `sub_item`.`sub_item_number`, `sub_item`.`sub_item_no`," +
      //         " `sub_item`.`cost`, '' AS 'available_count', '' AS 'total_quantity' , `unit`.`unit_name` FROM `sub_item_content`, " +
      //         "`main_item`, `sub_item`, `unit` WHERE `sub_item_content`.`status` = '1' AND `sub_item_content`.`content_id`" +
      //         " = `sub_item`.`sub_item_id` AND `main_item`.`main_item_id` = `sub_item`.`main_item_id` AND `unit`.`unit_id` =" +
      //         " `sub_item`.`unit_id` AND `sub_item_content`.`sub_item_id` = '" + sub_item_id + "'";
      //       let obj = { cmd: 'getList', query: query };

      //       this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      //         .subscribe(data => {
      //           this.applicationConstants.appComp.hideBusyCursor();
      //           this.dp = data.data['list'];

      //           //this.sub_item_number = 
      //           let count_obj;
      //           let content;
      //           let total_cost = 0;

      //           this.dp.forEach(element => {
      //             //console.log(element);
      //             total_cost += Number(element.cost);
      //             count_obj = {
      //               cmd: 'getSubItemByBarcode', sub_item_no: element.sub_item_no,
      //               invoice_item: [], store_id: '1'
      //             };
      //             this.utils.invokeHttp(this.applicationConstants.saleFuncFile, count_obj)
      //               .subscribe(data => {
      //                 this.applicationConstants.appComp.hideBusyCursor();
      //                 content = data.status.msg[0];
      //                 // console.log(content);
      //                 // if (content.available_count != undefined)
      //                 element.unit_id = content.unit_id;
      //                 element.available_count = content.available_count;
      //                 element.available_stock = content.available_stock;
      //               });

      //           });
      //           this.base_model['cost_per_unit'] = total_cost.toFixed(2);
      //           this.dataSource = new MatTableDataSource(this.dp);
      //           this.dataSource.sort = this.sort;

      //           // console.log(this.dp);

      //           // this.utils.invokeHttp(this.applicationConstants.generalFile, count_obj)
      //           //   .subscribe(data => {

      //           //     this.applicationConstants.appComp.hideBusyCursor();
      //           //     this.dp.forEach(element => {
      //           //       if (data.status['msg'][0].available_count != undefined)
      //           //         element.available_count = data.status['msg'][0].available_count;
      //           //       this.get_stock_no(element);
      //           //       //element.available_count = 200;
      //           //     });
      //           //     this.dataSource = new MatTableDataSource(this.dp);
      //           //     this.dataSource.sort = this.sort;

      //           //   });
      //         });
      //     });
    }

  }

  calculate_total() {
    if (this.model['sub_item_number'] != '') {
      this.model['primary_quantity'] = String((Number(this.model['quantity']) * Number(this.data_mode['output_qty'])).toFixed(2));
      this.stock_model['quantity'] = this.model['primary_quantity'];
      this.base_model['baseline_amount'] = this.model['primary_quantity'];

      this.dp.forEach(element => {
        let total_quantity = Number(this.model['quantity']) * Number(element.quantity);
        element.total_quantity = total_quantity;
      });
      console.log(this.model['primary_quantity']);
    }
  }

  // To get the max stock number for the item that will be produced
  // get_stock_no(sub_item_number) {
  //   //let sub_item_number = row['sub_item_number'];
  //   let query1 = "SELECT MAX(`stock_no`) AS 'stock_no' FROM `stock_base` WHERE `status` = '1' AND `sub_item_number` = '" +
  //     sub_item_number + "'";
  //   let obj1 = { cmd: 'getList', query: query1 };
  //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj1)
  //     .subscribe(data => {
  //       this.applicationConstants.appComp.hideBusyCursor();
  //       let stock_number = data.data['list'];
  //       // if (stock_number['0']['stock_no'] != null) {
  //       //   (document.getElementById('stock_no_' + row['sub_item_content_id']) as HTMLInputElement).value = String(Number(stock_number['0']['stock_no']) + 1);
  //       //   //this.stock_no = String(Number(stock_number['0']['stock_no']) + 1);
  //       // }
  //       // else {
  //       //   (document.getElementById('stock_no_' + row['sub_item_content_id']) as HTMLInputElement).value = '1';
  //       //   //this.stock_no = '1';
  //       //}
  //     });
  // }

  add() {
    if ((document.getElementById('production_date') as HTMLInputElement).value == '') {
      (document.getElementById('production_date') as HTMLInputElement).focus();
      alert(this.Prod_Date_Msg);
      return false;
    }

    if (this.model['sub_item_number'] == '') {
      (document.getElementById('search_value_0') as HTMLInputElement).focus();
      alert(this.Prod_Item_Msg);
      return false;
    }

    if (this.model['quantity'] == '') {
      (document.getElementById('quantity') as HTMLInputElement).focus();
      alert(this.Prod_Quant_Msg);
      return false;
    }

    if (this.data_mode['is_expire'] == '1' && (document.getElementById('expiry_date') as HTMLInputElement).value == '') {
      (document.getElementById('expiry_date') as HTMLInputElement).focus();
      alert(this.Expiry_Msg);
      return false;
    }

    if (this.dp.length == 0) {
      alert(this.Industrial_Item_Msg);
      return false;
    }

    let available = true;
    let element;
    for (let index = 0; index < this.dp.length; index++) {
      element = this.dp[index];
      if (Number(element.available_count) < Number(element.total_quantity)) {
        available = false;
        break;
      }
    }

    if (!available) {
      alert(this.Total_Quant_Msg1 + element.main_item_name + " (" + element.sub_item_no + ") " + this.Total_Quant_Msg2);
      return false;
    }

    let values = [];
    this.model['production_date'] = this.data_mode['production_date'].getFullYear() + "-" +
      (this.data_mode['production_date'].getMonth() + 1) + "-" + this.data_mode['production_date'].getDate() + ' ' +
      (new Date()).getHours() + ':' + (new Date()).getMinutes() + ':' + (new Date()).getSeconds();

    this.stock_model['stock_date'] = this.model['production_date'];
    this.base_model['base_date'] = this.model['production_date'];

    if (this.data_mode['is_expire'] == '1') {
      this.model['expiry_date'] = this.data_mode['expiry_date'].getFullYear() + "-" +
        (this.data_mode['expiry_date'].getMonth() + 1) + "-" + this.data_mode['expiry_date'].getDate();

      this.stock_model['expiry_date'] = this.model['expiry_date'];
      this.base_model['expiry_date'] = this.model['expiry_date'];
    }

    values.push(this.model);
    values.push(this.stock_model);
    values.push(this.base_model);

    // get the stock that will be used to consume the contnents
    let available_stock, counter, index = 0;

    this.dp.forEach(element => {
      available_stock = element.available_stock;
      counter = Number(element.total_quantity);

      available_stock.forEach(element1 => {
        if (counter > 0) {
          if (element1.available_count >= counter) {
            let store_id = this.applicationConstants.user_branch_info.user_store_id;
            values.push({
              'table_name': 'production_content', 'production_no': this.model['production_no'],
              'production_date': this.model['production_date'],
              'production_content_id': (index >= this.production_content_id.length ? '0' : this.production_content_id[index]['production_content_id']),
              'store_id': (index >= this.production_content_id.length ? store_id : element.store_id),
              'sub_item_number': element['content_number'], 'quantity': counter,
              'unit_id': element.unit_id, 'stock_no': element1.stock_no, 'key': 'production_content_id',
              'flag': (index >= this.production_content_id.length ? 'new' : 'update'),
              'primary_sub_item_number': element1.primary_sub_item_number,
              'primary_quantity': Number(element1.primary_qty) * counter
            });

            counter = 0;
          }
          else {
            let store_id = this.applicationConstants.user_branch_info.user_store_id;
            values.push({
              'table_name': 'production_content', 'production_no': this.model['production_no'],
              'production_date': this.model['production_date'],
              'production_content_id': (index >= this.production_content_id.length ? '0' : this.production_content_id[index]['production_content_id']),
              'store_id': (index >= this.production_content_id.length ? store_id : element.store_id),
              'sub_item_number': element['content_number'], 'quantity': element1.available_count,
              'unit_id': element.unit_id, 'stock_no': element1.stock_no, 'key': 'production_content_id',
              'flag': (index >= this.production_content_id.length ? 'new' : 'update'),
              'primary_sub_item_number': element1.primary_sub_item_number,
              'primary_quantity': Number(element1.primary_qty) * Number(element1.available_count)
            });

            counter -= element1.available_count;
          }
          index++;
        }
      });
    });

    for (; index < this.production_content_id.length; index++) {
      values.push({
        'table_name': 'production_content', 'key': 'production_content_id', 'flag': 'delete',
        'production_content_id': this.production_content_id[index]['production_content_id'],
        'production_no': this.model['production_no']
      });
    }

    console.log(values);
    let obj;
    if (this.model['production_id'] == '0')
      obj = { cmd: 'add', values: values, pk: 'production_no', id: 'production_id', main_table: 'production' };
    else
      obj = { cmd: 'updateAdv', values: values };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') {
          alert(this.Success_Msg);
          this.router.navigate(['sub_menu/11']);
        }
        else
          alert(this.Error_Msg);
      });

    // get the stock that will be used to consume the contnents
    // for (let element of this.dp) {
    //   if (Number(element.total_quantity) <= Number(element.available_count) && String(element.available_count) != '') {
    //     console.log(element);
    //     available_stock = element.available_stock;
    //     count = element.total_quantity;
    //     counter = Number(count);

    //     available_stock.forEach(as => {
    //       if (counter > 0) {
    //         if (as.available_count >= counter) {
    //           values.push({
    //             'table_name': 'production_content', 'production_no': '', 'production_date': this.model['production_date'], 'store_id': '1',
    //             'sub_item_number': element['sub_item_number'], 'qty': counter, 'unit_id': element.unit_id, 'stock_no': as.stock_no
    //           });

    //           counter = 0;
    //         }
    //         else {
    //           values.push({
    //             'table_name': 'production_content', 'production_no': '', 'production_date': this.model['production_date'], 'store_id': '1',
    //             'sub_item_number': element['sub_item_number'], 'qty': as.available_count, 'unit_id': element.unit_id, 'stock_no': as.stock_no
    //           });

    //           counter -= as.available_count;
    //         }
    //       }
    //     });



    //     // values.push({
    //     //   'table_name': 'production_content', 'production_no': '', 'unit_id': this.model['unit_id'], 'store_id':'0',
    //     //   'sub_item_number': element['sub_item_number'], 'production_date': new Date(), 'qty': this.model['quantity']
    //     //   });
    //   }
    //   else {
    //     available = false;
    //     alert(" كمية الإنتاج أكبر من الكميات المتاحة");
    //     break;
    //     //return;
    //   }

    // }

    // if (!available)
    //   return;

    // console.log(values);
    // let stock_no = '0';
    // let query1 = "SELECT MAX(`stock_no`) AS 'stock_no' FROM `stock_base` WHERE `status` = '1' AND `sub_item_number` = '" +
    //   this.model['sub_item_number'] + "'";
    // let obj1 = { cmd: 'getList', query: query1 };

    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj1)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     let stock_number = data.data['list'];
    //     if (stock_number['0']['stock_no'] != null) {
    //       //(document.getElementById('stock_no_' + row['sub_item_content_id']) as HTMLInputElement).value = String(Number(stock_number['0']['stock_no']) + 1);
    //       stock_no = String(Number(stock_number['0']['stock_no']) + 1);
    //     }
    //     else {
    //       //(document.getElementById('stock_no_' + row['sub_item_content_id']) as HTMLInputElement).value = '1';
    //       stock_no = '1';
    //     }
    //     // this.base_model['stock_no'] = stock_no;
    //     // this.model['stock_no'] = stock_no;
    //     // this.base_model['baseline_amount'] = this.model['quantity'];
    //     // this.base_model['base_date'] = this.model['production_date'];
    //     // values.push(this.model);
    //     // values.push(this.base_model);

    //     let obj = {
    //       cmd: 'add', values: values, pk: 'production_no', id: 'production_id',
    //       main_table: 'production'
    //     };

    //     this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //       .subscribe(data => {
    //         this.applicationConstants.appComp.hideBusyCursor();
    //         if (data.status['type'] == 'success') {
    //           alert(" تمت العملية بنجاح ");
    //           this.router.navigate(['sub_menu/11']);
    //         }
    //         else
    //           alert(" حدث خطأ الرجاء المحاولة مرة أخرى ");
    //       });
    //     //console.log(stock_no);
    //     //return;

    //   });


    //let values = [];
    //this.available = true;
    // this.dp.forEach(element => {
    //   let stock_no = document.getElementById('stock_no_' + element['sub_item_content_id']) as HTMLInputElement;

    //   if (Number(element.total_quantity) <= Number(element.available_count) || String(element.available_count) == '') {
    //     values.push({
    //       'table_name': 'production', 'production_id': '0', 'production_no': '', 'unit_id': this.model['unit_id'],
    //       'sub_item_number': element['sub_item_number'], 'production_date': new Date(), 'quantity': this.model['quantity']
    //     });
    //     values.push({
    //       'table_name': 'stock_base', 'baseline_id': '0', 'store_id': '1', 'baseline_amount': this.model['quantity'],
    //       'stock_no': stock_no.value, 'sub_item_number': element['sub_item_number'], 'base_date': new Date(),
    //       'source': 'production', 'reason': ''
    //     });
    //   }
    //   else
    //     this.available = false;

    // });
    // if (this.available) {
    //   let obj = { cmd: 'add', values: values, pk: 'production_no', id: 'production_id', main_table: 'production' };

    //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //     .subscribe(data => {
    //       this.applicationConstants.appComp.hideBusyCursor();
    //       if (data.status['type'] == 'success') {
    //         alert(" تمت العملية بنجاح ");
    //       }
    //       else
    //         alert(" حدث خطأ الرجاء المحاولة مرة أخرى ");
    //     });
    // }
    // else
    //   alert(" كمية الإنتاج أكبر من الكميات المتاحة");

  }

}

